import axios from "axios";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { Context } from "../../Reducers/Store";
import { usePermissao } from "../../Hooks/usePermissao";

export default function LayoutDashboard() {
  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { tem, podeVisualizarModulo } = usePermissao();

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2 rounded text-sm ${
      isActive
        ? "bg-slate-800 text-white"
        : "text-slate-300 hover:bg-slate-800"
    }`;

  const handleLogout = (e) => {
    e.preventDefault();
    const refreshToken = localStorage.getItem("refreshToken");
    axios.delete(`${process.env.REACT_APP_API}/auth`, {
      data: { refreshToken: refreshToken }
    }).then(res => {
      localStorage.removeItem("jwt");
      localStorage.removeItem("refreshToken");
      dispatch({ type: "SET_LOGGED", payload: null });
      navigate("/login");
    }).catch(error => {
      localStorage.removeItem("jwt");
      localStorage.removeItem("refreshToken");
      dispatch({ type: "SET_LOGGED", payload: null });
      navigate("/login");
    });
  };

  const handleNavClick = () => {
    setSidebarOpen(false);
  };

  // Define os itens do menu com suas permissões necessárias
  const menuItems = [
    {
      to: "/dashboard",
      label: "Dashboard",
      permissao: "dashboard.visualizar",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
    {
      to: "/controle-usuarios",
      label: "Logins SQL",
      permissao: "acessosbd.visualizar",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      to: "/excecoes",
      label: "Exceções",
      permissao: "excecoes.visualizar",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      ),
    },
    { separator: true },
    {
      to: "/monitoramento/queries-lentas",
      label: "Queries Lentas",
      permissao: "monitoramento.visualizar",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
    },
    { separator: true },
    {
      to: "/databases",
      label: "Databases",
      permissao: "bancos.visualizar",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
        </svg>
      ),
    },
    {
      to: "/grupos",
      label: "Grupos",
      permissao: "grupos.visualizar",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      ),
    },
    {
      to: "/usuarios",
      label: "Usuários",
      permissao: "usuarios.visualizar",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
    },
    {
      to: "/alterar-senha",
      label: "Alterar Senha",
      permissao: "meuperfil.alterarsenha",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
        </svg>
      ),
    },
    {
      to: "/backups",
      label: "Backups",
      permissao: "backups.visualizar",
      icon: (
        <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
        </svg>
      ),
    },
  ];

  return (
    <div className="h-screen flex bg-gray-100">
      {/* Overlay mobile */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-30
        bg-slate-900 text-white flex flex-col
        transform transition-all duration-300 ease-in-out
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        ${sidebarCollapsed ? 'lg:w-16' : 'lg:w-64'} w-64
      `}>
        <div className="h-16 flex items-center justify-between px-4 font-semibold border-b border-slate-800">
          {!sidebarCollapsed && <span className="truncate text-lg">SQL Server Manager</span>}
          
          <button 
            className="lg:hidden text-white"
            onClick={() => setSidebarOpen(false)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <button 
            className="hidden lg:block text-white hover:text-slate-300"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            title={sidebarCollapsed ? "Expandir menu" : "Colapsar menu"}
          >
            <svg className={`w-5 h-5 transition-transform ${sidebarCollapsed ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
            </svg>
          </button>
        </div>

        <nav className="flex-1 p-2 space-y-1 overflow-y-auto">
          {(() => {
            // Filtra itens que o usuário tem permissão (mantém separadores)
            const itensVisiveis = menuItems.filter((item) => {
              if (item.separator) return true;
              return !item.permissao || tem(item.permissao);
            });

            // Remove separadores problemáticos
            const itensFiltrados = [];
            
            for (let i = 0; i < itensVisiveis.length; i++) {
              const item = itensVisiveis[i];
              const anterior = itensFiltrados[itensFiltrados.length - 1];
              const proximo = itensVisiveis[i + 1];
              
              if (item.separator) {
                // Ignora se for o primeiro item
                if (itensFiltrados.length === 0) continue;
                
                // Ignora se o anterior já for separador
                if (anterior?.separator) continue;
                
                // Ignora se for o último item
                if (i === itensVisiveis.length - 1) continue;
                
                // Ignora se o próximo também for separador
                if (proximo?.separator) continue;
              }
              
              itensFiltrados.push(item);
            }

            return itensFiltrados.map((item, index) => {
              if (item.separator) {
                return <div key={`sep-${index}`} className="border-t border-slate-700 my-3"></div>;
              }

              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={linkClass}
                  onClick={handleNavClick}
                  title={item.label}
                >
                  {item.icon}
                  {!sidebarCollapsed && <span>{item.label}</span>}
                </NavLink>
              );
            });
          })()}
        </nav>

        <button
          onClick={handleLogout}
          className={`m-2 p-2 text-sm text-red-300 hover:text-red-200 hover:bg-slate-800 rounded flex items-center gap-3 ${sidebarCollapsed ? 'justify-center' : ''}`}
          title="Sair"
        >
          <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          {!sidebarCollapsed && <span>Sair</span>}
        </button>
      </aside>

      {/* Conteúdo */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 bg-white shadow px-4 sm:px-6 flex items-center justify-between shrink-0">
          <div className="flex items-center gap-4">
            <button 
              className="lg:hidden text-slate-700"
              onClick={() => setSidebarOpen(true)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            <span className="font-medium text-slate-700 truncate">
              Gerenciador SQL Server
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-gray-400 hidden sm:block">
              {state?.profile?.grupo_nome}
            </span>
            <span className="text-sm text-slate-500 truncate">
              Olá, {state?.profile?.name}
            </span>
          </div>
        </header>

        <main className="flex-1 p-4 sm:p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}